import React from "react";
import { strings } from "../../strings";
import styles from "./Hero.module.scss";

export default function Hero() {
  return (
    <div className={styles.wrapper}>
      <div
        className={styles.mainText}
        dangerouslySetInnerHTML={{ __html: strings.heroTxt }}
      />
      <div className={styles.subText}>{strings.subTxt}</div>
      <div
        className={styles.expainText}
        dangerouslySetInnerHTML={{ __html: strings.explainTxt }}
      />
    </div>
  );
}
